import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";import {ContentCopy} from '@mui/icons-material'
import {useState} from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import {Tooltip} from '../../../../ui/Tooltip/Tooltip'
import {TooltipContent} from '../../../../ui/Tooltip/TooltipContent'
import {TooltipTrigger} from '../../../../ui/Tooltip/TooltipTrigger'





export const CopyServiceProviderURL = (props) => {
  const {label, url} = props
  const title = `Copy the ${label}`
  const tooltip = `Copied! Paste it into your IdP`
  const [isOpen, setIsOpen] = useState(false)
  const onCopy = () => {
    setIsOpen(true)
    setTimeout(() => {
      setIsOpen(false)
    }, 2000)
  }

  return (
    _jsxs(_Fragment, { children: [
      _jsx('div', { className: "leading-7 font-bold" , children: label})
      , _jsx(CopyToClipboard, { text: url, title: title, tooltip: tooltip, onCopy: onCopy, children: 
        _jsxs('div', { className: "contents cursor-pointer" , children: [
          _jsx('div', { className: "break-all", children: url})
          , _jsxs(Tooltip, { open: isOpen, children: [
            _jsx(TooltipTrigger, { asChild: true, children: 
              _jsx(ContentCopy, { className: "h-5 w-5 text-sky-500 hover:text-sky-700"   ,} )
            })
            , _jsx(TooltipContent, { children: tooltip})
          ]})
        ]})
      })
    ]})
  )
}
